module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/project-module/project-modules/lock-module-for-review/lock-module-for-review.component.css
// module id = ./src/app/components/project-module/project-modules/lock-module-for-review/lock-module-for-review.component.css
// module chunks = main